/* eslint-disable react/prop-types */
import { Controller } from "react-hook-form";
import { Autocomplete, TextField } from "@mui/material";

const RHFDropdown = ({ formData, control, isDisabled, disableClearable }) => {
    // Generate validation rules dynamically
    const rules = formData?.Validations?.reduce((acc, validation) => {
        if (validation.ValidationType === "Required") {
            acc.required = validation.ValidationMessage || "This field is required";
        }
        return acc;
    }, {});

    return (
        <Controller
            name={formData?.ValueExpr}
            control={control}
            rules={rules}
            render={({ field: { onChange, onBlur, value, ref }, fieldState: { error } }) => (
                <Autocomplete
                    options={formData?.DefaultValues || []}
                    renderOption={(props, option) => (
                        <li {...props} key={option[formData?.ValueExpr]} style={{ fontSize: '13px' }}>
                            {option[formData?.DisplayExpr]}
                        </li>
                    )}
                    disabled={isDisabled}
                    disableClearable={!!disableClearable}
                    getOptionLabel={(option) => {
                        if (!option) return "";
                        return option[formData.DisplayExpr] || "";
                    }}
                    isOptionEqualToValue={(option, val) =>
                        String(option[formData.ValueExpr] ?? '') === String(val[formData.ValueExpr] ?? '')
                    }

                    value={value || null}

                    onChange={(event, newValue) => {
                        console.log(`[RHFDropdown] ${formData?.ValueExpr} onChange:`, newValue);
                        onChange(newValue);
                    }}
                    onBlur={onBlur}
                    ref={ref}

                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={<>{formData?.LabelName || formData?.DisplayExpr}{rules?.required && (
                                <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                            )}</>}
                            variant="outlined"
                            size="small"
                            // error={!!error}
                            helperText={
                                error && <span style={{ color: "red", fontSize: "10px" }}>{error.message}</span>
                            }
                            fullWidth
                            sx={{
                                "& .MuiInputBase-input": {
                                    fontSize: "13px",
                                },
                                "& .MuiFormLabel-root": {
                                    fontSize: "14px",
                                },
                                "& .MuiOutlinedInput-root": {
                                    backgroundColor: formData?.emptyFieldBgColor && !value ? formData.emptyFieldBgColor : undefined,
                                },
                            }}
                        />
                    )}
                />
            )}
        />
    );
};

export default RHFDropdown;
